import api from './api';

const portalService = {
  obtenerMisContratos: async () => {
    const { data } = await api.get('/auth/mi-contrato');
    return data.contratos ?? [];
  },

  obtenerMisPagos: async () => {
    const { data } = await api.get('/auth/mis-pagos');
    return data.pagos ?? [];
  },
};

export default portalService;
